import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { CaseStudies } from "@/components/CaseStudies";
import { Process } from "@/components/Process";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#FAFAFA] text-[#0A0A0A]">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Hero />
        <Stats />
        <CaseStudies />
        <Process />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}

export default App;
